export default class ExecutionFocusRuleType {
  constructor (raw) {
    this.id = raw.id
    this.name = raw.name
    this.inputType = raw.input_type
    this.description = raw.description || null
  }
}



// WEBPACK FOOTER //
// ./src/app/news_feed/models/ExecutionFocusRuleType.js